<template>
  <van-popup v-model="visible"
             v-bind="dialogAttributes"
             @close="close"
             class="template-dialog"
             :style="{ width: dialogAttributes.width || '100%', height: dialogAttributes.height || '100%'}">
    <div class="dialog-box">
      <div class="dialog-box-hd">{{ title }}</div>
      <div class="dialog-content">
        <component ref="contentcompnent"
                   :is="contentComponent"
                   @close="close"
                   @confirm="confirm"
                   :dialogParams="dialogParams" />
      </div>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: 'template-dialog',
  props: {
    // 标题 Object 类型为组件  string 类型为 文本
    title: {
      type: [String, Object],
      default: '提示',
    },

    // 内容组件
    contentComponent: [Function, Object],

    // 弹窗属性参数
    dialogAttributes: {
      type: Object,
      default: () => ({
        position: 'left',
        duration: 0.2,
        closeable: true
      })
    },

    // 传递给组件的参数
    dialogParams: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      visible: false
    }
  },
  methods: {
    confirm(parmas = {}) {
      // console.log('confirm', parmas)
      this.$emit('done', { ...parmas })
    },
    close(parmas = {}) {
      this.$emit('close', { ...parmas })
    }
  }
}
</script>
<style lang="less" scoped>
.template-dialog {
  ::v-deep .van-popup__close-icon--top-right {
    top: 12px;
    right: 12px;
  }
}
.dialog-box {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}
.dialog-box-hd {
  width: 100%;
  height: 46px;
  line-height: 46px;
  border-bottom: 1px solid #eee;
  font-size: 16px;
  color: #333;
  text-align: center;
  box-sizing: border-box;
}
.dialog-content {
  width: 100%;
  height: calc(100% - 46px);
  box-sizing: border-box;
  overflow: auto;
}
</style>